import React, { useEffect, useState } from 'react'
import { BinaryDemo } from './BinaryDemo'
import { useIsMobile } from '@/hooks/useMediaQuery'

interface HeroProps {
  isDark: boolean
  onDownload: () => void
}

export const Hero: React.FC<HeroProps> = ({ isDark, onDownload }) => {
  const [active, setActive] = useState(false)
  const isMobile = useIsMobile()

  useEffect(() => {
    const timer = setTimeout(() => setActive(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section className='relative h-screen flex flex-col justify-end p-6 md:p-12 pb-24 overflow-hidden'>
      <div className='max-w-7xl mx-auto w-full xl:max-w-none xl:mx-0'>
        <div className='mb-1 md:mb-6 xl:mb-12'>
          <span
            className={`mono text-[#0052FF] text-[18px] font-bold block ml-2 md:ml-8 transition-all duration-700 delay-100 ${
              active ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            HYPERAGENT // V0.1.82
          </span>
          <div className='flex flex-col lg:flex-row lg:items-end justify-between gap-8'>
            <h1
              className={`text-[14vw] leading-[0.8] font-inter font-black tracking-[-0.05em] uppercase mb-4 lg:mb-0 transition-all duration-1000 delay-200 text-zinc-900 dark:text-white ${
                active ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
            >
              GRAVITON
            </h1>
            <div
              className={`w-full lg:ml-auto lg:w-fit transition-all duration-700 delay-500 ${
                active ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
              }`}
            >
              {!isMobile && (
                <div className='flex flex-col items-end gap-3 text-right'>
                  <BinaryDemo isDark={isDark} onDownload={onDownload} />
                  <a
                    href='https://github.com/zayr0-9/yggchat'
                    target='_blank'
                    rel='noreferrer'
                    className='mono text-sm font-bold text-[#0052FF] hover:opacity-80 mr-6 transition-opacity'
                  >
                    GitHub →
                  </a>
                </div>
              )}
            </div>
          </div>

          <p
            className={`text-[18px] md:text-[26px] font-normal max-w-xl text-zinc-600 dark:text-zinc-300 transition-all duration-1000 delay-300 mt-6 ml-2 md:ml-8 ${
              active ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            When conversations become our memory.
          </p>
        </div>
      </div>
    </section>
  )
}
